
import Icon from "@/components/ui/AppIcon";

export default function Footer() {
  return (
    <footer className="border-t border-stone-border py-16 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + copyright */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-charcoal flex items-center justify-center">
            <Icon name="TruckIcon" size={16} className="text-cream" />
          </div>
          <span className="font-heading text-lg font-bold text-charcoal">
            Velocity<span className="text-amber italic font-normal">Cycles</span>
          </span>
          <span className="hidden md:block text-stone-warm text-sm ml-4">
            © 2026 VelocityCycles. All rights reserved.
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-6 text-sm font-medium text-stone-warm">
          <a href="#" className="hover:text-charcoal transition-colors">Privacy</a>
          <a href="#" className="hover:text-charcoal transition-colors">Terms</a>
          <a href="#" className="hover:text-charcoal transition-colors">Contact</a>
        </div>

        {/* Social */}
        <div className="flex items-center gap-3">
          {[
            { icon: "GlobeAltIcon", label: "Instagram" },
            { icon: "ChatBubbleLeftIcon", label: "Twitter" },
            { icon: "VideoCameraIcon", label: "YouTube" },
          ].map(({ icon, label }) => (
            <a
              key={label}
              href="#"
              aria-label={label}
              className="w-9 h-9 rounded-full border border-stone-border flex items-center justify-center text-stone-warm hover:text-charcoal hover:border-charcoal transition-all duration-200"
            >
              <Icon name={icon as any} size={16} />
            </a>
          ))}
        </div>

        {/* Mobile copyright */}
        <p className="md:hidden text-stone-warm text-xs">
          © 2026 VelocityCycles. All rights reserved.
        </p>
      </div>
    </footer>
  );
}